var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function () {
          return [
            _c(
              "div",
              { staticClass: "single container-max page-content" },
              [
                _c("div", { staticClass: "row position-relative" }, [
                  _c(
                    "div",
                    { staticClass: "mt-5 col-12 col-md-7" },
                    [_vm._t("image-carousel")],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-12 col-md-5 mt-md-5 single-sticky-top",
                    },
                    [
                      _c(
                        "div",
                        [
                          _vm.currentVariation.filter.hasManufacturer
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "producertag h6 producer text-muted",
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .externalName
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "h1",
                            {
                              staticClass: "h2 title",
                              attrs: { "data-testing": "item-name" },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm._f("itemName")(_vm.currentVariation)
                                    ) +
                                    "\n                            "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._t("tag-list"),
                          _vm._v(" "),
                          _vm.isShortDescriptionActive &&
                          _vm.currentVariation.texts.shortDescription !== ""
                            ? _c("p", {
                                staticClass: "single-description",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.currentVariation.texts.shortDescription
                                  ),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c("div", { staticClass: "mb-3" }, [
                            _c(
                              "span",
                              { staticClass: "articlenumber small text-muted" },
                              [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemNumber"
                                      )
                                    ) + "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.currentVariation.item.id)),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.attributes.length || Object.keys(_vm.units).length
                            ? _c(
                                "div",
                                { staticClass: "mb-3" },
                                [_c("variation-select")],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentVariation.variation.bundleType === "bundle"
                            ? _c("item-bundle", {
                                attrs: {
                                  "bundle-type":
                                    _vm.currentVariation.variation.bundleType,
                                  "bundle-components":
                                    _vm.currentVariation.bundleComponents,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._t("before-price"),
                          _vm._v(" "),
                          _vm.currentVariation.filter.isSalable &&
                          _vm.variationGroupedProperties.length
                            ? _c("div", [_c("order-property-list")], 1)
                            : _vm._e(),
                          _vm._v(" "),
                          _c("item-price", {
                            attrs: {
                              "show-cross-price": _vm.isRecommendedPriceActive,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "graduated-price__wrapper" },
                            [_c("graduated-prices")],
                            1
                          ),
                          _vm._v(" "),
                          _vm._t("after-price"),
                          _vm._v(" "),
                          _c("item-availability"),
                          _vm._v(" "),
                          _c("div", { staticClass: "my-3" }, [
                            _c(
                              "div",
                              { staticClass: "w-100" },
                              [_vm._t("before-add-to-basket")],
                              2
                            ),
                            _vm._v(" "),
                            _vm.downLoadLink
                              ? _c(
                                  "div",
                                  { staticClass: "add-to-basket-container" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn btn-block btn-primary btn-appearance",
                                        attrs: {
                                          type: "button",
                                          href:
                                            "https://cdn02.plentymarkets.com/oueuwrwk0stw/propertyItems/" +
                                            _vm.downLoadLink,
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    Download\n                                "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", [
                              _vm.currentVariation.item.itemType === "set"
                                ? _c(
                                    "div",
                                    { staticClass: "alert alert-info w-100" },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemSetInfo"
                                            )
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "my-3 col-12 col-sm-7 col-md-12 col-lg-8",
                                    },
                                    [
                                      _c("add-to-basket", {
                                        attrs: {
                                          "variation-id":
                                            _vm.currentVariation.variation.id,
                                          "is-salable":
                                            !!_vm.currentVariation.filter &&
                                            _vm.currentVariation.filter
                                              .isSalable,
                                          "has-children":
                                            !!_vm.currentVariation.filter &&
                                            _vm.currentVariation.filter
                                              .hasActiveChildren,
                                          "interval-quantity":
                                            _vm.currentVariation.variation
                                              .intervalOrderQuantity || 1,
                                          "minimum-quantity":
                                            _vm.currentVariation.variation
                                              .minimumOrderQuantity,
                                          "maximum-quantity":
                                            !!_vm.currentVariation.variation
                                              .maximumOrderQuantity &&
                                            _vm.currentVariation.variation
                                              .maximumOrderQuantity > 0
                                              ? _vm.currentVariation.variation
                                                  .maximumOrderQuantity
                                              : null,
                                          "order-properties":
                                            _vm.currentVariation.properties.filter(
                                              function (prop) {
                                                return prop.property
                                                  .isOderProperty
                                              }
                                            ),
                                          "has-order-properties":
                                            _vm.currentVariation
                                              .hasOrderProperties,
                                          "has-required-order-property":
                                            _vm.currentVariation
                                              .hasRequiredOrderProperty,
                                          "use-large-scale": false,
                                          "show-quantity": true,
                                          "item-url": _vm._f("itemURL")(
                                            _vm.currentVariation
                                          ),
                                          "is-variation-selected":
                                            _vm.isVariationSelected &&
                                            _vm.currentVariation.filter
                                              .isSalable,
                                          "has-price": _vm._f(
                                            "hasItemDefaultPrice"
                                          )(_vm.currentVariation),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "w-100" },
                              [_vm._t("after-add-to-basket")],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.isWishListEnabled
                            ? _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-12 wishlist-wrapper" },
                                  [
                                    _c("add-to-wish-list", {
                                      attrs: {
                                        "variation-id":
                                          _vm.currentVariation.variation.id,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "shipping__wrapper" }, [
                            _c("div", { staticClass: "shipping__headline" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$translate(
                                      "ODZwergentraeume::Template.shippingHeadline"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                            _vm._v(" "),
                            Math.round(
                              _vm.currentVariation.prices.default.price.value *
                                100
                            ) /
                              100 <
                            300
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "shipping__text shipping__text--de",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$translate(
                                            "ODZwergentraeume::Template.shippingDe"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "shipping__text shipping__text--de-free",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$translate(
                                            "ODZwergentraeume::Template.shippingDeFree"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                          ]),
                          _vm._v(" "),
                          _vm._t("additional-content-after-add-to-basket"),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _vm.filteredVariationProperties.length > 0
                            ? _c(
                                "div",
                                { staticClass: "properties__wrapper" },
                                _vm._l(
                                  _vm.filteredVariationProperties,
                                  function (property) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass: "properties",
                                        class: {
                                          "d-block":
                                            property.cast === "multiSelection",
                                        },
                                      },
                                      [
                                        property.names
                                          ? _c(
                                              "strong",
                                              {
                                                staticClass:
                                                  "properties__property-name",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(property.names.name)
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        property.values &&
                                        property.cast == "file"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "properties__property-value",
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "https://cdn02.plentymarkets.com/oueuwrwk0stw/propertyItems/" +
                                                        property.values.value,
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [_vm._v("Download")]
                                                ),
                                              ]
                                            )
                                          : property.values
                                          ? [
                                              property.cast === "multiSelection"
                                                ? _vm._l(
                                                    property.values,
                                                    function (val) {
                                                      return _c("div", {
                                                        staticClass:
                                                          "properties__property-value",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            val.value
                                                          ),
                                                        },
                                                      })
                                                    }
                                                  )
                                                : _c("span", {
                                                    staticClass:
                                                      "properties__property-value",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        property.values.value
                                                      ),
                                                    },
                                                  }),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._t("additional-content-after-vat"),
                        ],
                        2
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-7" }, [
                    _c("div", { staticClass: "my-5" }, [
                      _c("ul", { staticClass: "nav nav-tabs" }, [
                        _c("li", { staticClass: "nav-item" }, [
                          _c("span", { staticClass: "nav-link active" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.singleItemDescription"
                                )
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "overflow-hidden tab-content" },
                        [
                          _c(
                            "div",
                            { staticClass: "overflow-auto tab-pane active" },
                            [
                              _c("div", {
                                staticClass: "my-4",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.currentVariation.texts.description
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("hr", { staticClass: "desc-line" }),
                              _vm._v(" "),
                              _vm._t("properties"),
                              _vm._v(" "),
                              _c("hr", { staticClass: "desc-line" }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "my-4",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.currentVariation.texts.technicalData
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _vm.hasManufacturerDataPart2 ||
                              _vm.hasManufacturerDataPart1
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "mt-5 d-block",
                                      attrs: {
                                        "data-target": "#eusafety",
                                        "data-toggle": "modal",
                                        href: "#",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    ⓘ Herstellerinformationen\n                                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.isGuaranteeLabelVisible
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "col-12 col-md-5 mb-4 mt-md-5 single-guarantee-label",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "widget widget-guarantee-label" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "guarantee-badge-toggle btn-collapse p-0 border-0 bg-transparent",
                                  class: {
                                    collapsed: !_vm.guaranteeLabelExpanded,
                                  },
                                  attrs: {
                                    type: "button",
                                    "aria-expanded":
                                      _vm.guaranteeLabelExpanded.toString(),
                                    "aria-label": _vm.$translate(
                                      "ODZwergentraeume::Template.guaranteeLabelToggle"
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.guaranteeLabelExpanded =
                                        !_vm.guaranteeLabelExpanded
                                    },
                                  },
                                },
                                [
                                  _c("guarantee-badge", {
                                    attrs: {
                                      guarantee:
                                        _vm.currentVariation.variation
                                          .durabilityYears,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.guaranteeLabelExpanded
                                ? _c(
                                    "div",
                                    { staticClass: "guarantee-label-collapse" },
                                    [
                                      _c("guarantee-label-full", {
                                        attrs: {
                                          guarantee:
                                            _vm.currentVariation.variation
                                              .durabilityYears,
                                          brand:
                                            _vm.currentVariation.item
                                              .manufacturer.name,
                                          model:
                                            _vm.currentVariation.variation
                                              .model,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm._t("dropzone"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "single-item-list-container" },
                  [_vm._t("item-list-container")],
                  2
                ),
                _vm._v(" "),
                _vm._t("feedback-container"),
              ],
              2
            ),
          ]
        },
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField,
        }
      ),
      _vm._v(" "),
      _c("div", { attrs: { id: "eusafety-wrapper" } }, [
        _c(
          "div",
          {
            staticClass: "modal fade",
            attrs: { id: "eusafety", tabindex: "-1", role: "dialog" },
          },
          [
            _c("div", { staticClass: "modal-dialog" }, [
              _c("div", { staticClass: "modal-content" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", [
                    _vm.hasManufacturerDataPart1
                      ? _c("div", [
                          _vm.manufacturerData.name
                            ? _c("div", [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.manufacturerData.name) +
                                    "\n                                "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.manufacturerData.street ||
                          _vm.manufacturerData.houseNo
                            ? _c("div", [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.manufacturerData.street) +
                                    " " +
                                    _vm._s(_vm.manufacturerData.houseNo) +
                                    "\n                                "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.manufacturerData.postcode ||
                          _vm.manufacturerData.town
                            ? _c("div", [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.manufacturerData.postcode) +
                                    " " +
                                    _vm._s(_vm.manufacturerData.town) +
                                    "\n                                "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.manufacturerCountry != ""
                            ? _c("div", [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.manufacturerCountry) +
                                    "\n                                "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.manufacturerData.email
                            ? _c("div", [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.manufacturerData.email) +
                                    "\n                                "
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasManufacturerDataPart2
                      ? _c("div", { staticClass: "mt-4" }, [
                          _c("div", { staticClass: "h4" }, [
                            _vm._v("EU-Verantwortlicher"),
                          ]),
                          _vm._v(" "),
                          _vm.manufacturerData.responsibleName
                            ? _c("div", [
                                _vm._v(
                                  _vm._s(_vm.manufacturerData.responsibleName)
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.manufacturerData.responsibleStreet ||
                          _vm.manufacturerData.responsibleHouseNo
                            ? _c("div", [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.manufacturerData.responsibleStreet
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.manufacturerData.responsibleHouseNo
                                    )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.manufacturerData.responsiblePostCode ||
                          _vm.manufacturerData.responsibleTown
                            ? _c("div", [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.manufacturerData.responsiblePostCode
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.manufacturerData.responsibleTown
                                    ) +
                                    "\n                                "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.responsibleManufacturerCountry != ""
                            ? _c("div", [
                                _vm._v(
                                  _vm._s(_vm.responsibleManufacturerCountry) +
                                    "\n                                "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.manufacturerData.responsibleEmail
                            ? _c("div", [
                                _vm._v(
                                  _vm._s(_vm.manufacturerData.responsibleEmail)
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentVariation.barcodes
                      ? _c("div", { staticClass: "mt-2 pt-2 border-top" }, [
                          _vm._v(
                            "EAN: " +
                              _vm._s(_vm.currentVariation.barcodes[0].code)
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("div", { staticClass: "modal-title h3" }, [
        _vm._v(
          "\n                            Herstellerinformationen\n                        "
        ),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            "aria-label": "Close",
            "data-dismiss": "modal",
            type: "button",
          },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }